var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Box-row"},[_c('h4',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.model.name || _vm.operation))])])}
var staticRenderFns = []

export { render, staticRenderFns }